import axios from 'axios';

const API = axios.create({});

export default API;
